import { ButtonIcon } from '@statsbomb/kitbag-components';
import { useSetAtom } from 'jotai';
import PropTypes from 'prop-types';
import React from 'react';
import { useIntl } from 'react-intl';
import { messageDataSyncActionAtom } from '../../../atoms/messages';
import useApi, { API_ENDPOINTS } from '../../../hooks/api';

export function RequestEventsUpdate({ matchId, requestSeasonUpdate }) {
  const api = useApi();
  const intl = useIntl();

  const setMessageDataSyncAction = useSetAtom(messageDataSyncActionAtom);

  const handleClick = async () => {
    const seasonEndpoint = `/update-competition-season-events`;
    const singleMatchEndpoint = `/events/request-update`;
    const response = await api.post(
      `${API_ENDPOINTS.videoService}/data/FOOTBALL/matches/${matchId}${
        requestSeasonUpdate ? seasonEndpoint : singleMatchEndpoint
      }`,
    );
    if (response?.data) {
      setMessageDataSyncAction({
        text: intl.formatMessage({
          defaultMessage: 'Events updates resync requested',
          id: '5bfeb',
        }),
      });
    } else {
      setMessageDataSyncAction({
        text: intl.formatMessage({
          defaultMessage: 'Request to resync events failed',
          id: 'f186c',
        }),
        type: 'error',
      });
    }
  };

  return (
    <ButtonIcon
      size="small"
      onClick={handleClick}
      icon="Refresh"
      title={intl.formatMessage({
        defaultMessage: 'Re-sync Events',
        id: '86047',
      })}
    />
  );
}

RequestEventsUpdate.propTypes = {
  matchId: PropTypes.string.isRequired,
  requestSeasonUpdate: PropTypes.bool,
};
RequestEventsUpdate.defaultProps = {
  requestSeasonUpdate: false,
};

export default { RequestEventsUpdate };
